/**
 * /equipment/cost-postings — layout. List page lives at
 * _auth.equipment.cost-postings.index.tsx; detail at
 * _auth.equipment.cost-postings.$postingId.tsx.
 */
import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/equipment/cost-postings")({
  component: () => <Outlet />,
});
